import {Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
const {Text} = Typography;
const Content = Layout;

const ELONA = () => {
  return (
    <Layout style={{borderStyle: 'solid', borderWidth: '2vh', margin: '-2vh -2vh -2vh -2vh', background: appColors['ColorG2'], borderTopColor: appColors['ColorX'], borderBottomColor: appColors['ColorX'], borderRightColor: appColors['ColorX'], borderLeftColor: appColors['ColorX']}}>
      <Layout style={{background: 'transparent', margin: '5.2vh 5.2vh 5.2vh 5.2vh'}}>
        <Content style={{background: 'inherit'}}>
          <Text className='BaseText6'>Firstly, we propose to do ELONA (Enzyme Linked Oligonucleotide Assay) as with this assay we can make a calibration curve with both aptamers (primary and secondary) and measure the affinity constant Kd and the dynamic range. The assay is a type of ELISA in which the secondary aptamer binds to the 96 plate with the biotin-streptavidin interaction; then the target protein (CRP in this case) is added and finally the primary aptamer modified with a thiol group joined to a gold nanoparticle is incubated. Washing is done after each incubation step, removing any non-bound molecules. The correct formation of the complex will be determined by measuring the red colorimetric signal. This part will allow us to determine the concentrations that can be measured with our design in different types of sample and confirm if all the complexes of our system formed correctly.</Text>
          <Layout style={{background: 'transparent'}}>
            <Content style={{marginLeft: '50%', transform: 'translateX(-50%)', marginTop: '2vh', width: '60vh', background: 'transparent'}}>
              <Image src='https://static.igem.wiki/teams/4464/wiki/wet-lab/13.png' preview={false}/>
              <p style={{textAlign: 'center'}}>Fig 12. Diagram of ELONA protocol. Created with BioRender.com.</p>
            </Content>
          </Layout>
        </Content>
      </Layout>
    </Layout>
  );
};

export default ELONA;
